import React from 'react';

import classNames from 'classnames';
import { Check, Minus } from 'lucide-react';

import 'css/components/_CheckboxV2.scss';

export interface Props
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange' | 'checked'> {
  size: 'small' | 'medium' | 'large';
  onChange?: (checked: boolean) => void;
  'aria-label': string;
  checked?: boolean | 'indeterminate';
}

const CheckboxV2 = ({
  'aria-label': ariaLabel,
  children,
  checked,
  onChange,
  className,
  size = 'medium',
  disabled,
  ...props
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.checked);
  };

  const Icon = checked === 'indeterminate' ? Minus : Check;

  return (
    <span className={classNames('checkboxV2', className, { [size]: true })}>
      <input
        {...props}
        className="checkboxV2Input"
        data-checked={checked}
        type="checkbox"
        checked={checked === 'indeterminate' ? false : checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <span className="checkboxBackground"></span>
      <Icon className="checkedIcon" />
    </span>
  );
};

export default CheckboxV2;
